import React, { Fragment, Suspense } from 'react';

// a "thenable" object that never resolves.
// throwing this thenable in a component will keep it in a perpetual "pending" state,
// which causes React Suspense to display its fallback.
const infiniteThenable = { then() {} };

function Suspender({ freeze, children }: { freeze: boolean; children: React.ReactNode }) {
    if (freeze) {
        // if freeze is true, throw the thenable to trigger Suspense fallback.
        throw infiniteThenable;
    }
    return <Fragment>{children}</Fragment>;
}

interface Props {
    freeze: boolean;
    children: React.ReactNode;
    placeholder?: React.ReactNode;
}

// freeze wraps its children in a Suspense boundary.
// when 'freeze' is true, the child component suspends rendering and shows the fallback.
export function Freeze({ freeze, children, placeholder = null }: Props) {
    return (
        <Suspense fallback={placeholder}>
            <Suspender freeze={freeze}>{children}</Suspender>
        </Suspense>
    );
}
